module.exports = __webpack_public_path__ + "e0106718/img/arrow-left-icon.785c715c.svg";